import React from 'react'
import * as style from '../styles/footer.module.css'

export default function Footer() {
  return (
    <footer className={style.footer}>Copyright Linden Law Group © 2021</footer>
  )
}
